// Farmer profile is a flat User payload; agronomist profile nests it under
// "user" plus region/biography at the root. Neither returns "isKyd" anymore
// (that concept predates the current role/permission model).
export class AccountDto {
  static fromRoleProfile(data, userRole) {
    const user = userRole === "agronomist" ? data?.user : data;

    return {
      id: "" + (user?.id ?? ""),
      userRoleId: data?.id,
      firstName: user?.firstName,
      lastName: user?.lastName,
      domains: user?.domains,
      dob: user?.dob,
      language: user?.language,
      phone: user?.phone,
      email: user?.email,
      taxNumber: user?.taxNumber,
      region: data?.region,
      biography: data?.biography,
      isKyd: data?.isKyd ?? false,
    };
  }

  // GET /users/profile/me/ — unified endpoint covering every role, not just
  // farmer/agronomist. Roles/team-scoped biography+region only exist under
  // "agronomist" when the user actually holds that role.
  static fromProfile(data) {
    const user = data?.user;
    const agronomist = data?.agronomist;

    return {
      id: "" + (user?.id ?? ""),
      userRoleId: agronomist?.id,
      firstName: user?.firstName,
      lastName: user?.lastName,
      domains: user?.domains,
      dob: user?.dob,
      language: user?.language,
      phone: user?.phone,
      email: user?.email,
      taxNumber: user?.taxNumber,
      region: agronomist?.region,
      biography: agronomist?.biography ?? data?.profile?.biography,
      isKyd: false,
      roles: data?.roles ?? [],
      activeRole: data?.activeRole,
    };
  }
}
